import { motion, AnimatePresence } from "framer-motion";
import { X, AlertTriangle } from "lucide-react";
import { TECH_SPECS } from "../../data/finishes";

export default function SpecsModal({ open, onClose }) {
  return (
    <AnimatePresence>
      {open && (
        <>
          <motion.div
            data-testid="specs-backdrop"
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            exit={{ opacity: 0 }}
            onClick={onClose}
            className="fixed inset-0 z-[90] bg-ink/60 backdrop-blur-sm"
          />
          <motion.aside
            data-testid="specs-drawer"
            initial={{ x: "100%" }}
            animate={{ x: 0 }}
            exit={{ x: "100%" }}
            transition={{ duration: 0.6, ease: [0.16, 1, 0.3, 1] }}
            className="fixed right-0 top-0 h-full w-full max-w-xl z-[95] bg-bone border-l border-ink/10 overflow-y-auto"
          >
            <div className="p-8 sm:p-12">
              <div className="flex items-start justify-between mb-14">
                <div>
                  <p className="font-mono text-[10px] uppercase tracking-[0.3em] text-beiged mb-4">Engineering Honesty</p>
                  <h2 className="font-serif text-3xl sm:text-4xl tracking-tight text-ink leading-[1.1]">
                    Design & material <em className="italic text-beiged">limits.</em>
                  </h2>
                </div>
                <button
                  data-testid="specs-close-btn"
                  onClick={onClose}
                  className="p-3 border border-ink/20 rounded-full text-ink hover:bg-ink hover:text-bone transition-colors"
                  aria-label="Close"
                >
                  <X size={16} strokeWidth={1.5} />
                </button>
              </div>

              <div className="space-y-0">
                {TECH_SPECS.map((s, i) => (
                  <div key={s.t} data-testid={`spec-item-${i}`} className="border-t border-ink/10 py-8">
                    <div className="flex items-baseline gap-4 mb-3">
                      <span className="font-mono text-[10px] text-beiged">0{i + 1}</span>
                      <AlertTriangle size={14} strokeWidth={1.5} className="text-beiged translate-y-0.5" />
                      <h3 className="font-serif text-xl text-ink">{s.t}</h3>
                    </div>
                    <p className="text-sm leading-relaxed text-muted2 pl-12">{s.d}</p>
                  </div>
                ))}
              </div>

              <p className="mt-12 font-serif italic text-lg text-ink2 leading-relaxed border-t border-ink/10 pt-8">
                “These are not flaws. They are the honest physics of honest materials — and we design around them.”
              </p>
            </div>
          </motion.aside>
        </>
      )}
    </AnimatePresence>
  );
}
